import {
  OpenLobby,
  OpenRecovery,
  PriceMargin,
  OpenCycleInventory,
  OpenCycleInventoryGraph,
  OpenInventoryPromotionsView,
  InactiveProducts,
  OpenKPIGraph,
  OpenLogin,
  OpenInventory,
  OpenPikingSystem,
  OpenWasteSystem,
  OpenGeneralPages,
  OpenSalesOrder,
  OpenPortalSalesOrder,
  OpenPurchaseOrder,
  OpenNewCustomer,
  OpenInvoices,
  OpenAccountsReceivable,
  OpenInvoicesReport,
  OpenShortsReport,
  OpenMOHReport,
  OpenSalesReport,
  OpenVendorReport,
  OpenPurchaseProcessReport,
  OpenActualInventoryReport,
  OpenHistoryInventoryReport,
  OpenDesignPage,
  OpenAutomaticPOPage,
  OpenReturnPurchaseOrder,
  OpenPriceMarginProdLine,
  OpenNewProductsToInclude,
  OpenPaymentRecord,
  OpenScanningReport,
  OpenTrackingReport,
  OpenWeightPerTravelReport,
  OpenHistoryPurchaseOrdersReport,
  OpenSalesOrdersReport,
  OpenVendorPriceChangeReport,
  OpenSpoilageReport,
  SalesTracker,
  OpenRouteSales,
  OpenCalculateMargins,
  OpenInventoryOverstock,
  OpenGeneralMarginPrices,
  OpenUsersManagement,
  OpenLogs,
  OpenPurchasing
} from './pagesFunction';

export const redirectMap = {
  Lobby: OpenLobby,
  Recovery: OpenRecovery,
  MargenesPrecio: PriceMargin,
  CycleInventory: OpenCycleInventory,
  CycleInventoryGraph: OpenCycleInventoryGraph,
  PromotionsView: OpenInventoryPromotionsView,
  InactiveProducts: InactiveProducts,
  KPIGraph: OpenKPIGraph,
  Login: OpenLogin,
  Inventory: OpenInventory,
  PikingSystem: OpenPikingSystem,
  WasteSystem: OpenWasteSystem,
  SalesOrder: OpenSalesOrder,
  PortalSalesOrder: OpenPortalSalesOrder,
  PurchaseOrder: OpenPurchaseOrder,
  NewCustomer: OpenNewCustomer,
  Invoices: OpenInvoices,
  AccountsReceivable: OpenAccountsReceivable,
  OpenInvoicesReport: OpenInvoicesReport,
  ShortsReport: OpenShortsReport,
  MOHReport: OpenMOHReport,
  SalesReport: OpenSalesReport,
  VendorReport: OpenVendorReport,
  PurchaseProcessReport: OpenPurchaseProcessReport,
  ActualInventoryReport: OpenActualInventoryReport,
  HistoryInventoryReport: OpenHistoryInventoryReport,
  DesignPage: OpenDesignPage,
  AutomaticPOPage: OpenAutomaticPOPage,
  ReturnPurchaseOrder: OpenReturnPurchaseOrder,
  PriceMarginProdLine: OpenPriceMarginProdLine,
  NewProductsToInclude: OpenNewProductsToInclude,
  PaymentRecord: OpenPaymentRecord,
  ScanningReport: OpenScanningReport,
  TrackingReport: OpenTrackingReport,
  WeightPerTravelReport: OpenWeightPerTravelReport,
  HistoryPurchaseOrdersReport: OpenHistoryPurchaseOrdersReport,
  SalesOrderReport: OpenSalesOrdersReport,
  VendorPriceChangeReport: OpenVendorPriceChangeReport,
  SpoilageReport: OpenSpoilageReport,
  SalesTracker: SalesTracker,
  RouteSalesReport: OpenRouteSales,
  CalculateMargin: OpenCalculateMargins,
  InventoryOverstock: OpenInventoryOverstock,
  GeneralMarginPrices: OpenGeneralMarginPrices,
  UsersManagement: OpenUsersManagement,
  LogsPage: OpenLogs,
  Purchasing: OpenPurchasing,
  GeneralPages: OpenGeneralPages,
};

export function executeRedirect(redirectTo) {
  if (redirectMap[redirectTo]) {
    redirectMap[redirectTo]();
  }
}
